import React from 'react';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import LightningStatus from 'new/elements/LightningStatus';
import DateUtils from 'js/lib/DateUtils';

const generateColumns = () => {
  return [
    {
      name: 'Name',
      field: 'name',
    },
    {
      name: 'Credential ID',
      field: 'id',
      renderRow: (row) => {
        return (
          <ChipWithCopy tooltipTitle="Copy Credential ID" toCopy={row.id}>
            ID {row.id}
          </ChipWithCopy>
        );
      },
    },
    {
      name: 'Created on',
      field: 'created_at',
      renderRow: (row) => DateUtils.convertDateStringToFormat(row.created_at),
    },
    {
      name: 'Status',
      field: 'validStatus',
      renderRow: (row) => {
        return <LightningStatus status={row.validStatus} />;
      },
    },
  ];
};

export default generateColumns;
